import React from "react";
import classes from "../../assets/styles/PriorityModal.module.css";
import { Button, Modal } from "react-bootstrap";
import crossicon from "../../assets/images/global_icons/crossicon.svg";
import FormInput from "../../components/Forms/FormInput";
const PriorityListingModal = ({
  show,
  sortedFunctionData,
  handlePriorityChange,
  handleSave,
  handleClose,
  respectMemberVisibility = false,
  canManageMemberVisibility = false,
  handleMemberVisibilityChange,
  updatingMemberVisibility = null,
  readOnlyAdminView = false,
}) => {
  return (
    <>
      <Modal
        centered
        className="customModal priorityModal square-modal2 mt-"
        size="md"
        show={show}
      >
        <Modal.Header className="priorityModalHeader d-flex justify-content-between">
          <span>Function Priority List</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleClose}
          />
        </Modal.Header>

        <Modal.Body className="priorityModalBody">
          {readOnlyAdminView && (
            <div className="alert alert-info mb-3" role="status">
              This team member is an admin and can access all function cards.
              Priority and visibility settings cannot be changed here.
            </div>
          )}
          <div className="imageUpload">
            {sortedFunctionData.map((functionItem, index) => (
              <div
                className="row function-row align-items-center mb-3"
                key={index}
              >
                <div className="col-lg-2 d-none">
                  <FormInput
                    type="text"
                    name="function_type"
                    label="Function Name"
                    value={functionItem.function_type}
                    disabled
                  />
                </div>
                <div className={canManageMemberVisibility ? "col-lg-6" : "col-lg-9"}>
                  <FormInput
                    type="text"
                    name="priority"
                    label={`Enter Priority Number for ${functionItem.title}`}
                    value={
                      functionItem.priority === 0 ? "" : functionItem.priority
                    }
                    handleChange={(e) =>
                      handlePriorityChange(index, e.target.value)
                    }
                    disabled={readOnlyAdminView}
                  />
                </div>
                {canManageMemberVisibility && (
                  <div className="col-lg-3">
                    <div className="form-check form-switch mt-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={functionItem.is_member_visible === true}
                        disabled={Boolean(updatingMemberVisibility)}
                        id={`isMemberVisible${index}`}
                        onChange={(event) =>
                          handleMemberVisibilityChange(
                            functionItem.function_type,
                            event.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label mb-0"
                        htmlFor={`isMemberVisible${index}`}
                      >
                        Members
                      </label>
                    </div>
                  </div>
                )}
                <div className="col-lg-3">
                  <div className="form-check mt-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={functionItem.is_visible === true}
                      disabled={
                        readOnlyAdminView ||
                        (respectMemberVisibility &&
                          functionItem.is_member_visible === false)
                      }
                      id={`isVisible${index}`}
                      onChange={(e) =>
                        handlePriorityChange(
                          index,
                          e.target.checked,
                          "is_visible"
                        )
                      }
                    />
                    <label
                      className="form-check-label mb-0"
                      htmlFor={`isVisible${index}`}
                    >
                      Visible
                    </label>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Button value="primary" onClick={handleSave}>
              Save
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default PriorityListingModal;
